<template>
    <div id="main-container">

        <!-- left panel -->
        <div style="float:left; width: 55%;">
            <!-- Live icon (flashing) -->
            <div style="position: relative;padding-left:20px;">
                <span :style="{color: getLiveStatusColour()}" style="font-weight: bold;">LIVE DATA</span>
                <svg height="50" width="50" :class="(getDeviceSleepStatus(item.deviceTimestamp) ? '' : 'blinking')" style="position:absolute; top:-9px; left:-11px;">
                    <circle cx="20" cy="20" r="5" :fill="getLiveStatusColour()" />
                </svg> 

                <span style="padding-left: 10px;">Last Communication: {{ item.formattedLastCommunicationSeconds }}</span>
            </div>
            <br />

            <div id="left-panel" style="display: block;">
                <h4>Device Details</h4>
                <div style="position: relative; float: left; top: 0px;">
                    <img v-if="item.online" class="card-background card-img-top online"
                        src="@/assets/images/smart-packaging-online.png" alt="...">
                    <img v-else class="card-background card-img-top" src="@/assets/images/smart-packaging-offline.png"
                        alt="...">
                </div>
                <!-- info box -->
                <div style="padding-top: 10px; padding-bottom: 0px;">

                    <div style="display: inline-block; padding-left: 10px; position: relative; float: left;">
                        <b>Device:</b> {{ item.id }}
                        <br />
                        <b>Type:</b> MIoT Track and Trace Device
                        <br />
                        <b>Location:</b> Global
                        <br />
                        <b>Last Active:</b> {{ (last_active_session_time != null ? last_active_session_time : "-") }}
                        <br />
                        <b>Carrier:</b> {{ (device != null && device.lastsession != null ? device.lastsession.network_name : "-") }} <b-badge v-if="device != null && device.lastsession != null" pill variant="info">{{ device.lastsession.radio_access_technology }}</b-badge>
                        <br />
                        <!-- <b>Status: </b> <span v-if="device" class="badge bg-success">Online</span><span v-else class="badge bg-secondary">Offline</span> -->
                        <b>State: </b><b-badge pill :variant="(device != null && device.lastsession != null ? 'primary' : 'success')">{{ (device != null && device.lastsession != null ? 'Connected' : 'Ready') }}</b-badge>
                    </div>
                </div>
                <!-- device data -->
                <div id="device-data"
                    style="display: inline-block; width: 100%; padding-top: 20px; padding-right: 20px; float: left; bottom: 0px;">
                    <h4>Sensor Data</h4>
                    <!-- Temperature Chart -->
                    <div>
                        <div style="position: relative;">
                            <h1
                                style="font-size: 48px; margin-bottom: 0; text-align: right; padding-right: 48px; padding-top: 0 !important;">
                                <span v-if="temperatureChange == 'D'" style="color: red">{{ temperature }} °C</span>
                                <span v-if="temperatureChange == 'U'" style="color: green">{{ temperature }} °C</span>
                                <span v-if="temperatureChange == '-'">{{ temperature }} °C</span>
                            </h1>
                            <div style="position: absolute; bottom: 0; right: 10px; font-size: 48px; padding-top: 0 !important;">
                                <font-awesome-icon v-if="temperatureChange == 'D'" icon="fa-solid fa-caret-down" style="color: red" />
                                <font-awesome-icon v-if="temperatureChange == 'U'" icon="fa-solid fa-caret-up" style="color: green" />
                            </div>
                            <div style="position: absolute; bottom: 9px; right: 10px; font-size: 48px;">
                                <font-awesome-icon v-if="temperatureChange == '-'" icon="fa-solid fa-minus" style="font-size:25px;" />
                            </div>
                        </div>
                        <div style="text-align: right; text-transform: uppercase; margin-bottom: 15px; padding-right: 10px;">temperature</div>
                        <div style="width:50%; height: 200px">
                            <canvas id="device-chart"></canvas>
                        </div>
                    </div>

                    <!-- Humidity  Chart -->
                    <div>
                        <div style="position: relative;">
                            <h1 style="font-size: 48px; margin-bottom: 0; text-align: right; padding-right: 48px;">
                                <span v-if="humidityChange == 'D'" style="color: red">{{ humidity }} %</span>
                                <span v-if="humidityChange == 'U'" style="color: green">{{ humidity }} %</span>
                                <span v-if="humidityChange == '-'">{{ humidity }} %</span>
                            </h1>
                            <div style="position: absolute; bottom: 0; right: 10px; font-size: 48px;">
                                <font-awesome-icon v-if="humidityChange == 'D'" icon="fa-solid fa-caret-down" style="color: red" />
                                <font-awesome-icon v-if="humidityChange == 'U'" icon="fa-solid fa-caret-up" style="color: green" />
                            </div>
                            <div style="position: absolute; bottom: 9px; right: 10px; font-size: 48px;">
                                <font-awesome-icon v-if="humidityChange == '-'" icon="fa-solid fa-minus" style="font-size:25px;" />
                            </div>
                        </div>
                        <div style="text-align: right; text-transform: uppercase; margin-bottom: 15px; padding-right: 10px;"> humidity</div>
                        <div style="width:50%; height: 200px">
                            <canvas id="device-chart-2"></canvas>
                        </div>
                    </div>
                </div>
                <br />
            </div>
        </div>
        <!-- Right panel -->
        <div style="position: relative; float:right; width: 45%; height: 100%; padding-top: 25px;">
            <h4 style="padding: 20px;">Device Location</h4>
            <!-- device location -->
            <div id="device-location" style="padding-right: 30px; margin-top: -20px;">
                <div v-if="item.coords != []">
                    <PackagingTracking_dynamic ref="PackagingTracking_dynamic" :item="item" :itemLocationHistory="miotSimLocationHistory" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment'
import Chart from 'chart.js';
import PackagingTracking_dynamic from '../PackagingTracking_dynamic.vue';


// Function to filter unique values based on lat and lon
const getUniqueValues = (array, latKey, lonKey) => {
  const seen = new Set();
  console.log("Filtering array. Length: " + array.length)
  return array.filter(item => {
    const lat = item[latKey];
    const lon = item[lonKey];
    const key = `${lat}-${lon}`;

    if (!seen.has(key)) {
      seen.add(key);
      return true;
    }
    return false;
  });
};

export default {
    name: 'MIoTCard',
    components: {
        PackagingTracking_dynamic,
    },
    data: function () {
        return {
            device: null,
            last_active_session_time: null,
            miotSimLocations: [],
            miotSimLocationHistory: [],

            sensorData: [],
            patentTest: "this is a parent!",
            SensorData: "", 
            piTemperatureData: {
                type: "line",
                data: {
                    labels: [],
                    datasets: [
                        {
                            label: "Temperature °C",
                            data: [],
                            backgroundColor: "rgba(54,73,93,.5)",
                            borderColor: "#36495d",
                            borderWidth: 3,
                            radius: 0
                        }                  
                    ]
                },
                options: {
                    maintainAspectRatio: false,
                    legend: {
                        display: false
                    },                    
                    animation: {
                        duration: 0
                    },                    
                    responsive: true,
                    lineTension: 1,
                    scales: {
                        yAxes: [
                            {
                                ticks: {
                                    beginAtZero: false,
                                    padding: 25
                                }
                            }
                        ]
                    }      
                }
            },
            temperature: null,
            temperatureChange: null,
            piHumidityData: {
                type: "line",
                data: {
                    labels: [],
                    datasets: [
                        {
                            label: "Humidity %",
                            data: [],
                            backgroundColor: "rgba(71, 183,132,.5)",
                            borderColor: "#47b784",
                            borderWidth: 3,
                            radius: 0
                        }
                    ]
                },
                options: {
                    maintainAspectRatio: false,
                    legend: {
                        display: false
                    },                       
                    animation: {
                        duration: 0
                    },                    
                    responsive: true,
                    lineTension: 1,
                    scales: {
                        yAxes: [
                            {
                                ticks: {
                                    beginAtZero: false,
                                    padding: 25
                                }
                            }
                        ]
                    }                     
                }
            },
            humidity: null,
            humidityChange: null,
            autoFetchData: false,
            autoRefreshDataInterval: null,
        };
    },
    props: ['item', 'autoUpdateDeviceData'],
    mounted: function () {
        // TODO: Make this not be hard-coded
        if (this.item.id == "MIoT-PROTO-1") this.item.simID = 2237323;
        if (this.item.id == "MIoT-PROTO-2") this.item.simID = 2372115;
        
        // Initial load of data
        this.getMIoTSimCurrentLocations();
        this.getMIoTSimHistoricLocations();
        this.getMIoTData();
        this.getSensorData();

        // Pi Temp sensor API auto-fetch
        this.autoRefreshDataInterval = setInterval(() => {
            if(this.autoFetchData) {
                this.getMIoTSimCurrentLocations();
                this.getMIoTSimHistoricLocations();
                this.getMIoTData();
                this.getSensorData();
            }
        }, 10000) // 10 sec
    },
    beforeDestroy() {
        this.humidity = null;
        this.temperature = null;
        this.piTemperatureData = null;
        this.piHumidityData = null;
        clearInterval(this.autoRefreshDataInterval);
    },
    methods: {
        getDeviceSleepStatus(timeStamp)
        {
            // Get the current time in milliseconds
            const currentTime = new Date().getTime();

            // Calculate the difference between the current time and the provided timestamp
            const difference = currentTime - timeStamp;

            // Check if the difference is greater than one minute (60 seconds * 1000 milliseconds)
            return difference > 60 * 1000;
        },
        getLiveStatusColour(){
            return this.getDeviceSleepStatus(this.item.deviceTimestamp)
            ? 'grey' // Change this to the color you want for timestamps more than one minute ago
            : 'red'; // Change this to the color you want for timestamps less than one minute ago 
        },
        async getMIoTSimCurrentLocations() {
            let url = process.env.VUE_APP_MULE_PROXY_API_URI;

            let headers = {
                'Content-Type': 'application/json;charset=utf-8',
                'authorization': localStorage.idtoken
            };

            var data = {
                "endpoint": "/api/hologram-proxy/?redirect_path=devices&uri_params=locations&orgid=68148"
            };

            data = JSON.stringify(data);

            try {
                const response = await this.$http.post(
                    url,
                    data,
                    { headers: headers }
                );

                var responseData = response.data.data

                for (var i = 0; i < responseData.length; i++) {
                    if (responseData[i].deviceid == this.item.simID) this.item.coords = { lat: (responseData[i].latitude == "" ? this.item.coords.lat : responseData[i].latitude), lng: (responseData[i].longitude == "" ? this.item.coords.lng : responseData[i].longitude) }
                }

            } catch (error) {
                console.log(error);
            }
        },
        async getMIoTSimHistoricLocations() {
            let url = process.env.VUE_APP_MULE_PROXY_API_URI;

            let headers = {
                'Content-Type': 'application/json;charset=utf-8',
                'authorization': localStorage.idtoken
            };

            var data = {
                "endpoint": "/api/dynamo-crud-proxy/"
            };

            data = JSON.stringify(data);

            try {
                const response = await this.$http.post(
                    url,
                    data,
                    { headers: headers }
                );

                var locationsHistoryResponseData = response.data

                // const today = new Date()
                for (var i = 0; i < locationsHistoryResponseData.length; i++) {
                    // var objDate = new Date(locationsHistoryResponseData[i].datetime)

                    if (/*(objDate.getYear() == today.getYear() && objDate.getMonth() == today.getMonth() && objDate.getDate() == today.getDate()) &&*/ locationsHistoryResponseData[i].device_id == this.item.simID) this.miotSimLocationHistory.push({ datetime: locationsHistoryResponseData[i].datetime, lat: locationsHistoryResponseData[i].latitude, lng: locationsHistoryResponseData[i].longitude })
                }

                console.log("Sim locations history orig:")
                console.log(this.miotSimLocationHistory)

                console.log("Sim locations history after distinct:")
                this.miotSimLocationHistory = getUniqueValues(this.miotSimLocationHistory, 'lat', 'lng')
                console.log(this.miotSimLocationHistory)

            } catch (error) {
                console.log(error);
            }
        },
        async getMIoTData() {
            let url = process.env.VUE_APP_MULE_PROXY_API_URI;

            let headers = {
                'Content-Type': 'application/json;charset=utf-8',
                'authorization': localStorage.idtoken
            };

            var data = {
                "endpoint": "/api/hologram-proxy/?redirect_path=devices&uri_params=" + this.item.simID + "&orgid=68148"
            };

            data = JSON.stringify(data);

            try {
                const response = await this.$http.post(
                    url,
                    data,
                    { headers: headers }
                );

                this.device = response.data.data;

                if (this.device.lastsession != null) this.last_active_session_time = moment(this.device.lastsession.session_start).fromNow();

            } catch (error) {
                console.log(error);
            }

        },
        async getSensorData() {
            // for Packaging Device 2
            let url = "https://xct6d7fy58.execute-api.ap-southeast-2.amazonaws.com/beta"; 

            // for Packaging Device 3
            if(this.item.id == "Packaging Device 3") {
                url = "https://s9tfb3de53.execute-api.ap-southeast-2.amazonaws.com/default"; 
            }

            let headers = {
                'x-api-key': 'NMKFcHIzMT7ToX0O9eRXW7yXA22zGM0B7ddc8Xpy'
            };                

            try {
                const response = await this.$http.get(
                    url,
                    {headers: headers}
                );

                //console.log(response.data.Items[0].itemData[29]);

                var sensorDataArray = [];
                var datasetZero = [];
                var datasetOne = [];
                var labels = [];

                // console.log("---DEBUG---")
                // console.log(response.data);
                // console.log("---END DEBUG---")


                for(var i = 0; i < response.data.Items[0].itemData.length; i++) {

                    // tempdata object
                    var tempData = response.data.Items[0].itemData[i].deviceTempData.split(" "); // example "1650500757 21.2 49.""

                    // format timestamp
                    var adjustedTimestamp = parseInt(tempData[0] + "000");

                    var ts = new Date(parseInt(adjustedTimestamp));
                    //console.log(ts);

                    var tsa = ts.toLocaleString('en-AU').toUpperCase();
                    var tsb = ts.toLocaleString('en-us', {  weekday: 'short' }) + ' ' + tsa;
                    var tsc = tsb.replace(',', '');

                    var sensorData = {
                        timestamp: tsc,
                        sensorTemp: tempData[1],
                        sensorHumidity: tempData[2],
                    }

                    sensorDataArray.push(sensorData);
                    datasetZero.push(tempData[1]);
                    datasetOne.push(tempData[2]);

                    var cts = ts.toString().split(' ');
                    labels.push(cts[4]);
                }

                // data for table
                this.sensorData = sensorDataArray.reverse();

                // data for chart and redraw chart
                this.piTemperatureData.data.labels = labels;
                this.piTemperatureData.data.datasets[0].data = datasetZero;
                this.temperature = datasetZero[29];

                if(this.temperature > datasetZero[28]) {
                    this.temperatureChange = "U"
                } else if(this.temperature < datasetZero[28]) {
                    this.temperatureChange = "D"
                } else {
                    this.temperatureChange = "-"
                }

                this.piHumidityData.data.labels = labels;
                this.piHumidityData.data.datasets[0].data = datasetOne;     
                this.humidity = datasetOne[29]      
                
                if(this.humidity > datasetOne[28]) {
                    this.humidityChange = "U"
                } else if(this.humidity < datasetOne[28]) {
                    this.humidityChange = "D"
                } else {
                    this.humidityChange = "-"
                }                
                
                // Temperature  Chart
                const ctx = document.getElementById('device-chart');
                new Chart(ctx, this.piTemperatureData);       
                
                // Humidity  Chart
                const ctx2 = document.getElementById('device-chart-2');
                new Chart(ctx2, this.piHumidityData);            
                
                document.getElementById("live-data-loading").style.display = 'none';
                document.getElementById("live-data-container").style.display = 'block';                

            } catch (error) {
                console.log(error);
            }
        },
    }
}
</script>
<style></style>
